import React, { useEffect } from "react";
import {
  WSAlert,
  WSControlGroup,
  WSDropFileInput,
  WSElement,
  WSFlexBox,
  WSForm,
  WSIcon,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import styles from "../../../components/CreateRequirementDefinitionForm/styles.module.scss";
import { useFormContext } from "react-hook-form";
import { useESignatureAgreementTemplatesInfo } from "../../../../../userFeatures/useESignatureAgreementTemplatesInfo";
import { openInNewTab } from "../../../../../shared/utils/openInNewTab";

export const CreateSignaturePartialForm: React.FC = () => {
  const { register, setValue } = useFormContext();

  const customInfo = useESignatureAgreementTemplatesInfo();

  useEffect(() => {
    register("eSignatureFile");
    register("requiredSignatures");
  }, []);

  return (
    <WSList gap="XL">
      <WSAlert
        theme="info"
        title="About e-Signature requirements"
        action={
          customInfo?.actionTitle
            ? {
                text: customInfo.actionTitle,
                onClick: () => openInNewTab(customInfo.actionLink)
              }
            : undefined
        }
      >
        Contractor(s) assigned with this requirement will be asked to e-sign the
        document uploaded here.
        {customInfo?.description ? (
          <>
            <WSElement mt="M" />
            {customInfo.description}
          </>
        ) : null}
      </WSAlert>

      <WSForm.Value name="eSignatureFile">
        {(file?: File) =>
          file ? (
            <>
              <WSElement p="XL" className={styles.selectedFile}>
                <WSFlexBox.CenterY wrap="nowrap">
                  <WSText className={styles.selectedFileName} singleLine>
                    {file.name}
                  </WSText>
                  <WSFlexBox>
                    <WSIcon
                      block
                      color="gray500"
                      size="M"
                      mx="M"
                      name="exit"
                      onClick={() => {
                        setValue("eSignatureFile", undefined);
                      }}
                    />
                  </WSFlexBox>
                </WSFlexBox.CenterY>
              </WSElement>
              <WSForm.Field
                name="requiredSignatures"
                label="Required signatures"
                component={WSControlGroup}
                componentProps={{
                  required: true,
                  type: "radio",
                  options: [
                    {
                      value: "collaborator",
                      label: "Contractor signature required only"
                    },
                    {
                      value: "mutual",
                      label:
                        "Both contractor and company signatures are required"
                    }
                  ]
                }}
              />
            </>
          ) : (
            <WSElement>
              <WSText.ParagraphSm mb="S" color="gray500">
                Upload e-Signature file *
              </WSText.ParagraphSm>
              <WSDropFileInput
                name="dropFileInput"
                buttonText="Browse files"
                buttonProps={{
                  type: "button"
                }}
                accept=".pdf"
                onDropAccepted={accepted => {
                  setValue("eSignatureFile", accepted[0]);
                }}
              />
            </WSElement>
          )
        }
      </WSForm.Value>
      <WSText.ParagraphXs weight="book" color="gray400">
        Wingspan can auto-fill known info like names, emails, custom fields
        which you can configure in the next step.
      </WSText.ParagraphXs>
    </WSList>
  );
};
